export default __webpack_public_path__ + "1d53337ae36caef5a0e807d0b2cbe8df.svg";